export const SET_CARD_SUMMARY = 'SET_CARD_SUMMARY'
export const TOGGLE_CARD_VISIBILITY = 'TOGGLE_CARD_VISIBILITY'
export const SET_ALL_CARD_VISIBLE = 'SET_ALL_CARD_TRUE'
export const SET_HOME_FILTER_DATE_RANGE = 'SET_HOME_FILTER_DATE_RANGE'
export const SET_HOME_FILTER_OUTLET_ID = 'SET_HOME_FILTER_OUTLET_ID'
export const SET_HOME_FILTER_CALENDAR_DROPDOWN =
  'SET_HOME_FILTER_CALENDAR_DROPDOWN'
